import {Link, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();
    const location = useLocation();

    function getYear() {
        return new Date().getFullYear();
    }

    // A tournament detail page is its own contained view (own header/tabs/
    // bottom nav, per-tournament content still streaming in - info fields,
    // banner image, draws) - this footer doesn't belong there to begin with
    // (already hidden under 768px via CSS), and mounting it there just made
    // it flash in low, still un-positioned by the not-yet-loaded content
    // above it, before settling near the true bottom a moment later. Same
    // isTournamentPage check as Header.js's own (which already hides its
    // theme/language controls there for the same "this page has its own
    // chrome" reason).
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const tournamentIndex = pathSegments.indexOf("tournaments");
    const isTournamentPage = tournamentIndex !== -1 && pathSegments.length > tournamentIndex + 1;
    if (isTournamentPage) return null;

    return (
        <div className="footer">
            <div className="footer-container">
                <div>
                    <small>
                        <Link to="/">
                            Link Tournament
                        </Link>
                    </small>
                </div>
                <div className="right">
                    <small>
                        &copy; 2022-{getYear()} {t("Rights")}
                    </small>
                </div>
            </div>
        </div>
    )
}